import React, { useEffect, useState } from 'react'
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp'
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import MultipleSelect from '../../../Components/SelectionComp/MultipleSelect';
import InfoIcon from '@mui/icons-material/Info';
import CustomInput from '../../../Components/InputCompo/CustomInput';
import { useNavigate } from 'react-router-dom';
const GeographyAdv = ({ values, errors, setFieldValue, handleChange, stateDatas, districtsDatas, reCallApi, setAdvPostData, reset, tabs, setTabs }) => {
    const [onHoverInfo, setOnHoverInfo] = useState(false)
    const navigate = useNavigate()
    const searchParams = new URLSearchParams(window.location.search);
    const advancedSearchMiniTab = searchParams.get('advancedSearchMiniTab');
    const advancedSearchUrlQuery = searchParams.get('AdvancedSearch');
    const miniTab = JSON.parse(decodeURIComponent(advancedSearchMiniTab))

    const viewTabs = (name) => {
        if (miniTab?.[name]) {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: false }))}`, { replace: true });
        } else {
            navigate(`/search?advancedSearchMiniTab=${encodeURIComponent(JSON.stringify({ ...tabs, [name]: true }))}`, { replace: true });
        }
    }

    useEffect(() => {
        if (advancedSearchMiniTab) {
            setTabs(miniTab)
        }
    }, [advancedSearchMiniTab])







    useEffect(() => {
        if (advancedSearchUrlQuery) {
            try {
                const parsedData = JSON.parse(decodeURIComponent(advancedSearchUrlQuery));
                // reCallApi(parsedData);
                setAdvPostData(parsedData);
            } catch (error) {
                console.error("Error parsing search query:", error);
            }
        }
    }, [advancedSearchUrlQuery]);



    const openInfo = () => {
        setOnHoverInfo(true)
    }
    const closeInfo = () => {
        setOnHoverInfo(false)
    }
    const multiSelectedValues = (name, value) => {

        setFieldValue(name, value)
    }
    return (
        <>

            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='All India' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('All India')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>
                </div>
                {tabs?.["All India"] &&
                    <div className='mt-[20px]'>
                        <CustomSelection disabledFilter={true} value={values?.['pan_india']} onChange={handleChange} name='pan_india' mappingKey='option' options={[{ option: 'Yes' }, { option: 'No' }]} label='Select' />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['pan_india'] && errors?.['pan_india']} />
                    </div>
                }
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='State' className={`${values?.['pan_india'] === "Yes" ? 'text-[#00487874]' : 'text-[#004878]'}`} />
                    <div className='cursor-pointer' onClick={() => viewTabs('State')}>
                        <ArrowDropDownCircleIcon className={`${values?.['pan_india'] === "Yes" ? 'text-[#00487874]' : 'text-[#004878]'} text-[30px]`} />
                    </div>
                </div>
                {tabs?.["State"] &&
                    <div className='mt-[20px]'>
                        <CustomSelection disabled={values?.['pan_india'] === "Yes"} value={values?.state} onChange={handleChange} name='state' options={stateDatas?.['state list']} label='Select' />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['state'] && errors?.['state']} />
                    </div>
                }
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <div className='flex relative gap-[5px] items-center'>
                        <ParagraphComp text='District' className={`${values?.['pan_india'] === "Yes" ? 'text-[#00487874]' : 'text-[#004878]'}`} />
                        {!values?.['state'] &&
                            <div onMouseLeave={closeInfo} onMouseEnter={openInfo}>
                                <InfoIcon className={`${values?.['pan_india'] === "Yes" ? 'text-[#00487874]' : 'text-[#004878]'}`} id='InfoSize' />
                                {onHoverInfo &&
                                    <div className='p-[5px] rounded-bl-none ml-[16px] mt-[-55px] transition-[3s] w-max text-sm absolute rounded-full bg-gray-200'>
                                        Choose District from the State selected above
                                    </div>
                                }
                            </div>
                        }

                    </div>
                    <div className='cursor-pointer' onClick={() => viewTabs('District')}>
                        <ArrowDropDownCircleIcon className={`${values?.['pan_india'] === "Yes" ? 'text-[#00487874]' : 'text-[#004878]'} text-[30px]`} />
                    </div>
                </div>
                {tabs?.["District"] &&
                    <div className='mt-[20px]'>
                        <MultipleSelect
                            labelColor={'black'}
                            disabled={values?.['pan_india'] === "Yes" || !values?.['state']}
                            options={districtsDatas?.['district_list']?.filter(ele => ele?.value === values?.['state'])}
                            mappingKey={'option'} // Pass mapping key if needed
                            onValueChange={(name, values) => multiSelectedValues(name, values)}
                            selectedValues={values?.['district'] || []}
                            name='district'
                            label={values?.['state'] ? 'select' : 'Select District only after State'}
                        />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['district'] && errors?.['district']} />
                    </div>
                }
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex justify-between items-center'>
                    <ParagraphComp text='City/ Town/ Taluka/ Village' className={`text-[#004878]`} />
                    <div className='cursor-pointer' onClick={() => viewTabs('City')}>
                        <ArrowDropDownCircleIcon className={`text-[#004878] text-[30px]`} />
                    </div>
                </div>
                {tabs?.["City"] &&
                    <div className='mt-[20px]'>
                        <CustomInput onChange={handleChange} value={values?.['city']} name='city' label='Enter' />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['city'] && errors?.['city']} />
                    </div>
                }
            </div>
            <div className='p-[10px] rounded-xl mt-[20px] bg-[white]'>
                <div className='flex relative justify-between items-center'>
                    <ParagraphComp text='Pincode' className='text-[#004878]' />
                    <div className='cursor-pointer' onClick={() => viewTabs('Pincode')}>
                        <ArrowDropDownCircleIcon className='text-[30px] text-[#004878]' />
                    </div>

                </div>
                {tabs?.["Pincode"] &&
                    <div className='mt-[20px]'>
                        <CustomInput type='number' onChange={handleChange} value={values?.['pincode']} name='pincode' label='Enter' />
                        <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={values?.['pincode'] && errors?.['pincode']} />
                    </div>
                }
            </div>


        </>
    )
}

export default GeographyAdv